<style src="./Hint.scss" lang="scss"></style>

<template lang="pug">
  .hint(
    :class='classList'
  ) {{ content }}
</template>

<script>
export default {
  props: {
    content: String,
    position: {
      type: String,
      default: "right"
    },
    type: String
  },
  computed: {
    classList() {
      return {
        [`is-${this.position}`]: true,
        [`is-${this.type}`]: this.type
      };
    }
  }
};
</script>
